import { Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import "./SignaturePadComponentV2.css";

function SignaturePadComponentV2({
  onSignatureSave,
  signatureDataURL,
  toWho,
  onSignatureValidate,
}) {
  const [signatureValidated, setSignatureValidated] = useState(false);

  const sigPad = useRef();

  const getDataURLFromCanvas = () => {
    return sigPad.current.getTrimmedCanvas().toDataURL("image/png");
  };

  const handleClear = () => {
    sigPad.current.clear();
    onSignatureSave(null);
    setSignatureValidated(false);
    onSignatureValidate(false);
  };

  const handleSave = () => {
    const dataURL = getDataURLFromCanvas();
    onSignatureSave(dataURL);
    setSignatureValidated(true);
    onSignatureValidate(true);
  };

  useEffect(() => {
    if (sigPad.current) {
      sigPad.current.onBegin = () => {
        setSignatureValidated(false);
        onSignatureValidate(false);
      };
    }
  }, [sigPad, onSignatureValidate]);

  return (
    <section className="signature-pad-card" aria-label="Client signature">
      <div className="signature-pad-heading">
        <div>
          <p className="signature-pad-kicker">Final step</p>
          <h4>Client signature</h4>
        </div>
        <span className="signature-pad-step">1 of 1</span>
      </div>

      <p className="signature-pad-instruction">
        Sign in the box below, then validate your signature to complete this form.
      </p>

      <div className="signature-pad-surface">
        <SignaturePad
          penColor="#173b68"
          velocityFilterWeight={0.7}
          minWidth={0.5}
          maxWidth={2.5}
          canvasProps={{
            className: "signature-pad-canvas",
            "aria-label": "Signature drawing area",
          }}
          ref={sigPad}
        />
        <span className="signature-pad-baseline" aria-hidden="true" />
        <span className="signature-pad-hint">Draw your signature here</span>
      </div>

      <div className="signature-pad-footer">
        <div className="signature-pad-status" role="status" aria-live="polite">
          {signatureValidated ? (
            <span className="signature-status is-valid">
              <span className="signature-status-dot" /> Signature validated
            </span>
          ) : (
            <span className="signature-status">
              <span className="signature-status-dot" /> Awaiting validation
            </span>
          )}
        </div>

        <div className="signature-pad-actions">
          <Button className="signature-pad-clear" onClick={handleClear}>
            Clear
          </Button>
          <Button className="signature-pad-validate" onClick={handleSave}>
            Validate signature
          </Button>
        </div>
      </div>
    </section>
  );
}

export default SignaturePadComponentV2;
